import React from "react";

const ProgressStepIcon = (props) => {
    const { isComplete, isActive, label, className } = props;

    let cssBgColor = "bg-skin-light";
    if (isActive) {
        cssBgColor = "bg-skin-blended";
    }
    if (isComplete) {
        cssBgColor = "bg-green-50";
    }

    return (
        <span
            className={`grid place-items-center rounded-full h-6 w-6 ${cssBgColor} ${className}`}
        >
            {isComplete ? (
                <div className="inline-block h-4 w-2 origin-center rotate-45 border-b-[3px] border-r-[3px] border-green-600"></div>
            ) : (
                <p
                    className={
                        isActive
                            ? "text-skin-primary text-center font-semibold"
                            : ""
                    }
                >
                    {label}
                </p>
            )}
        </span>
    );
};

export default ProgressStepIcon;
